/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
// import { formatCoverageValue } from 'Utils';
import { ViewQuotationPdfButton } from '@shared/components/buttons/ViewQuotationPdfButton';
import './index.css';

const cardPackageDiff = (props) => {

  const { packageItem, insuranceCarrier } = props;

  const payment = packageItem.payments.find((paymentIterator) => paymentIterator.id === 'ANUAL');
  return (
    <div className="container-package-diff c01361">
      <div className="img-package-diff">
        <img
          className="c01353"
          src={insuranceCarrier.logo_url}
          alt="logoInsurance"
        />
      </div>
      {/*<div style={{ marginBottom: '10px', display: 'inline-block', color: '#5f5f5f' }}>#{packageItem.number}</div>*/}
      {packageItem?.complete_public_url ? (
        <div style={{ textAlign: 'center', flex: 1 }}>
          {/* <a href={packageItem?.complete_public_url} target="_blank">
            <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: '40px', color: '#ff4d4d', cursor: 'pointer' }} />
            <p style={{ marginBottom: '0px' }}>PDF</p>
          </a> */}
          <ViewQuotationPdfButton url={packageItem?.complete_public_url} style={{ fontSize: '2.5em' }} />
        </div>
      ) : ''}
      {/*<div>
        <span className="name-package">{packageItem.package_detail}</span>
        <br />
      </div>
      <div>
        <div>
          <div>
            <span className="payment-text">pago contado</span>
            <span className="payment-value">&nbsp;{formatCoverageValue(payment.value)}</span>
          </div>
        </div>
      </div>*/}
    </div>
  );
};

cardPackageDiff.propTypes = {
  packageItem: PropTypes.any.isRequired,
  insuranceCarrier: PropTypes.any.isRequired,
};


export default cardPackageDiff;
